<template>
  <div class="home">
    <div class="banner">
      <v-card flat dark outlined>
        <div class="card-body">
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">Premium</div>
              <v-list-item-title class="headline mb-1">
                ALPHYIAGO
              </v-list-item-title>
              <v-list-item-subtitle
                >Even world-famous fashion brands like Prada and Versace have
                entered the online space to become closer to existing and new
                customers.</v-list-item-subtitle
              >
            </v-list-item-content>

            <v-list-item-avatar tile size="55" class="mb-10">
              <v-img src="/img/logo.png"></v-img>
            </v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-btn class="ml-2" color="green"> shop now </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </div>

    <div class="brand-content">
      <v-container>
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-layout row class="brand-container">
              <v-flex xs6 sm6 md6>
                <div class="lottie-inside">
                  <lottie :options="defaultOptions" />
                </div>
              </v-flex>
              <v-flex xs6 sm6 md6>
                <v-card>
                  <v-card-text>
                    <h1 class="black--text">INFINITY STYLES</h1>
                    <p class="red--text font-weight-bold">Join with us ...</p>
                    <p class="font-weight-bold mb-1">The shop is open</p>
                    <h3>A PERFECT BLEND OF STYLE AND FUNCTION</h3>
                    <p>All sizes available</p>
                    <div>
                      <v-btn dark color="red"> shop online </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="products-one">
      <ProductsOne />
    </div>

    <div class="carousel">
      <Carousel />
    </div>

    <div class="products-two">
      <ProductsTwo />
    </div>

    <div class="container">
      <Social />
    </div>
  </div>
</template>

<script>
import Lottie from '@/components/Lottie.vue'
import animationData from '../assets/img/animated/fashion.json'
import Carousel from '@/components/Carousel'
import Social from '@/components/Social'
import ProductsOne from '@/components/ProductsOne'
import ProductsTwo from '@/components/ProductsTwo'
export default {
  name: 'Home',
  data() {
    return {
      defaultOptions: { animationData: animationData },
      animationSpeed: 1,
      show: false,
      email: '',
    }
  },
  components: {
    lottie: Lottie,
    Social,
    ProductsOne,
    ProductsTwo,
    Carousel,
  },
  methods: {
    subscribe() {
      this.email = ''
    },
  },
}
</script>
<style>
.home-header .logo-wrapper {
  display: block;
  text-align: center;
}
.home .v-card .school-name {
  color: #0026ca;
}
.home .v-sheet.v-card {
  box-shadow: none;
}
.home ul li {
  list-style: none;
}
.home ul {
  padding-bottom: 20px;
}
</style>
